<template>
	<div class="modal-wrapper">
		<div class="login-wrapper">
			<div class="login-inner">
				<p class="title">세션이 만료되었습니다.</p>

				<p class="description">비밀번호를 입력하고 로그인하여 작업을 다시 진행하세요!</p>

				<div class="input-wrapper" @submit="login">
					<layout-styled-input
						title="비밀번호 입력"
						key-index="login-pw-field"
						v-model="editable.password"
						type="password"
						class="input"
						:is-init-focus="true"
						:callback="() => { login(editable) }"
					/>

					<div class="submit-button" @click="login">
						<svg
							:fill="isEmptyPassword ? '#999999' : '#3d9cff'"
							version="1.1"
							id="Capa_1"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0px"
							y="0px"
							viewBox="0 0 481.5 481.5"
							style="enable-background:new 0 0 481.5 481.5;"
							xml:space="preserve"
						>
							<g>
								<g>
									<path
										d="M0,240.7c0,7.5,6,13.5,13.5,13.5h326.1l-69.9,69.9c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l93-93
                    c5.3-5.3,5.3-13.8,0-19.1l-93-93c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1l69.9,69.9h-326C6,227.2,0,233.2,0,240.7z"
									/>
									<path
										d="M382.4,0H99C44.4,0,0,44.4,0,99v58.2c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V99c0-39.7,32.3-72,72-72h283.5
                    c39.7,0,72,32.3,72,72v283.5c0,39.7-32.3,72-72,72H99c-39.7,0-72-32.3-72-72V325c0-7.5-6-13.5-13.5-13.5S0,317.5,0,325v57.5
                    c0,54.6,44.4,99,99,99h283.5c54.6,0,99-44.4,99-99V99C481.4,44.4,437,0,382.4,0z"
									/>
								</g>
							</g>
						</svg>
					</div>
				</div>

				<div class="before-login-wrapper">
					<div class="login-section">
						<span class="login-title">로그인 아이디 :</span>
						<span class="login-id">{{ editable.email || '아이디가 없습니다.' }}</span>
					</div>

					<span class="logout-button" @click="logout">로그아웃</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LayoutStyledInput from "@/spa/components/LayoutStyledInput";

export default {
	name: "ModalRetryLogin",
	components: {
		LayoutStyledInput
	},
	props: {
		param: Object
	},
	computed: {
		isEmptyPassword() {
			return !this.editable.password;
		}
	},
	methods: {
		async login() {
			if (this.isEmptyPassword) {
				this.$toast("비밀번호를 입력해주세요.");
				return;
			}

			const result = await this.$store.dispatch("login", this.editable);

			if (result.response) {
				this.$store.commit("setFoldState", false);
				this.intervalTokenCheck();
				this.closed();
			}

			this.$toast(result.message);
		},

		async logout() {
			const result = await this.$store.dispatch("logout", this.editable);

			if (result.response) {
				this.$router.push("/").catch(error => {
					if (error.name != "NavigationDuplicated") {
						throw error;
					}
				});
				this.closed();
			}

			this.$toast(result.message);
		},

		closed() {
			this.$modal.clearComponent();
		}
	},
	data() {
		return {
			editable: {
				password: "",
				email: this.param.email
			},

			intervalTokenCheck: this.param.intervalTokenCheck
		};
	}
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	align-items: center;

	width: 100vw;
	height: 100vh;

	background-color: rgba(0, 0, 0, 0.2);

	.login-wrapper {
		position: relative;

		width: 600px;
		height: 320px;

		background-color: rgb(255, 255, 255);
		border-radius: 15px;

		.login-inner {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;
			align-items: flex-start;

			width: 100%;

			padding: 50px;

			.title {
				font-size: 24px;
				color: rgba(0, 0, 0, 0.9);
			}

			.description {
				color: rgba(0, 0, 0, 0.7);
			}

			.input-wrapper {
				position: relative;

				width: 100%;
				height: auto;

				.input {
					width: 100%;
					height: 60px;
					margin-top: 24px;
				}

				.submit-button {
					position: absolute;
					z-index: 15;

					right: 0;
					bottom: 25px;

					width: 24px;
					height: 24px;

					cursor: pointer;
				}
			}

			.before-login-wrapper {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-content: center;
				align-items: center;

				width: 100%;

				.login-section {
					.login-title {
						color: rgba(0, 0, 0, 0.6);
						margin-right: 12px;
					}

					.login-id {
						color: rgba(0, 0, 0, 0.7);
					}
				}

				.logout-button {
					color: rgba(0, 0, 0, 0.8);
					cursor: pointer;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalRetryLogin.vue